import { Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import moment from 'moment';
import { SharedModule } from 'src/app/shared/shared.module';
import { MarketService } from '../market.service';
import { MaterialDateRangeComponent, DateRange } from 'src/app/shared/components/material-date-picker/material-date-range.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-market-toolbar',
  templateUrl: './market-toolbar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SharedModule,
    MaterialDateRangeComponent,
    MatButtonModule,
    MatIcon,
  ],
})

export class MarketToolbarComponent implements OnInit {
  @Output()
    date: EventEmitter<DateRange> = new EventEmitter<DateRange>();

  dateRange: DateRange = {
    startDate: new Date(),
    endDate: new Date()
  };
  action: boolean = false;

  excelExporting? : (service: MarketService) => void;

  constructor(private _router: Router,
    private _marketService: MarketService
  ) { }

  ngOnInit(): void {
    if (!this.dateRange) {
      this.dateRange = {
        startDate: moment(new Date()).subtract(100, 'days').toDate(),
        endDate: new Date()
      };
    }
  }

  selectDateRange(dateRange: DateRange) {
    if (dateRange) {
      this.date.emit(dateRange);
    }
  }

  marketFiles() {
    this._router
      .navigate([
        'pricing/files',
      ])
      .then((_) => _);
  }

  pricingList() {
    this._router
      .navigate([
        'pricing/list',
      ])
      .then();
  }

  excelExport() {
    if(this.excelExporting) {
      this.excelExporting(this._marketService);
    }
  }

}